import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App.tsx'
import './index.css'
import { ErrorBoundary } from './components/ErrorBoundary'
import './utils/scriptSafety'
import './utils/diagnostics'

// Additional protection against ads script React errors
const originalReactError = console.error
console.error = function(...args) {
  const message = args[0]?.toString() || ''
  if (message.includes('Minified React error #130') &&
      (message.includes('ads') || new Error().stack?.includes('ads'))) {
    console.warn('🚫 [MAIN] Blocked ads React error from console')
    return
  }
  return originalReactError.apply(console, args)
}

// Add global diagnostic access for debugging
if (typeof window !== 'undefined') {
  (window as any).getDiagnostics = () => {
    const diagnostics = (window as any).__diagnostics__;
    if (diagnostics) {
      const report = diagnostics.getDiagnosticReport();
      console.table(report.logs?.slice(-10) || []);
      return report;
    }
    return { error: 'Diagnostics not available' };
  };
  
  console.log('🔍 [DEBUG] Diagnostic system active. Use window.getDiagnostics() to view report.');
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary componentName="Root App">
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>,
)